import { useNavigate } from 'react-router';
import { NotFoundLayout, NotFoundHeader, NotFoundSubheader, NotFoundIconWrapper } from './styles';
import NotFoundIcon from './images/404.svg?react';
import { Button } from '@/components/Button/Button';

import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate(getLoginPath());
  };

  return (
    <NotFoundLayout>
      <NotFoundIconWrapper>
        <NotFoundIcon></NotFoundIcon>
      </NotFoundIconWrapper>
      <NotFoundHeader>Page Not Found</NotFoundHeader>
      <NotFoundSubheader>
        We cannot find the page you are looking for!
        <br />
        Please try again.
      </NotFoundSubheader>
      <Button width={200} onClick={navigateToLogin} variant='secondary'>
        Return to Login
      </Button>
    </NotFoundLayout>
  );
};
